// removed by extract-text-webpack-plugin
module.exports = {"content":"_2R32EBGnFyc_ZnInKlWXZB","title":"O-49XRSbKfTkDoyuMuGLj","author":"o7UVKxxP4lEI3YcMe9qS","userdata":"_1itNH9dEo5yQ3wZvCKfx0v","data":"MIW9kAYZR6ZCTymPd_Udx"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/organisms/Article/style.css
// module id = 516
// module chunks = 38